(function agencyAppLandingpagePage () {
    $(() => {
      $('.cetelem-app-landingpage .loading').css('display', 'none');

      $('.cetelem-app-landingpage .credito').addClass("show");
      $('.cetelem-app-landingpage .headerLeft .text').addClass("show");

        $('.cetelem-app-landingpage .headerRight .picture').addClass("show");
      $('.cetelem-app-landingpage .headerRight .text').addClass("show");
  });
})()